// src/components/BrandLogo.jsx — wordmark from public/david-meyer-logo.png
import React from "react";

/** @param {"light" | "dark"} variant — light = invert for dark backgrounds (sidebar / hero) */
export default function BrandLogo({ variant = "dark", style, className }) {
  const src = `${process.env.PUBLIC_URL}/david-meyer-logo.png`;
  return (
    <img
      src={src}
      alt="David Meyer"
      className={className}
      style={{
        maxWidth: variant === "dark" ? 240 : 200,
        width: "100%",
        height: "auto",
        display: "block",
        objectFit: "contain",
        ...(variant === "light"
          ? { filter: "brightness(0) invert(1)", opacity: 0.94 }
          : {}),
        ...style,
      }}
    />
  );
}
